import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import usePagination from 'hooks/usePagination';
import { Loading } from 'components';
import { BOARD_NOTICE_MODULE_NO } from 'data/constants';

import boardService from 'services/board/board-service';
import NoticeView from './NoticeView';

// 기본은 공지사항(module 1). 다른 게시판은 moduleNo/title/desc/basePath 를 넘겨 재사용 (pages/community/board/Board.js)
export function Notice({
  moduleNo = BOARD_NOTICE_MODULE_NO,
  title,
  desc,
  basePath = '/community/notice',
  useQueryContentNo = false,
}) {
  const navigate = useNavigate();
  const { langList } = useOutletContext();
  const [loading, setLoading] = useState(true);
  const [noticeList, setNoticeList] = useState();
  // 페이지네이션
  const [searchParams] = useSearchParams();
  const { paginationRequest, setPaginationRequest, paginationResult, setPaginationResult } = usePagination(navigate, searchParams);

  const list = {
    ...langList.notice,
    subject: title !== undefined ? title : langList.notice.subject,
    subjectDesc: desc !== undefined ? desc : langList.notice.subjectDesc,
  };

  // 상세 페이지 이동 onClick
  const goDetail = (item) => {
    // 상세 URL 에 항상 ?contentNo= 를 붙인다 (새로고침·검색엔진 크롤링·서버 SEO 렌더링용). state 는 기존 호환용
    navigate(`${basePath}/view?contentNo=${item.contentNo}`, { state: { contentNo : item.contentNo } });
  };

  useEffect(() => {
    async function fetchNotices() {
      let data = [];

      try {
        const response = await boardService.listContents(moduleNo, paginationRequest.pageNumber, paginationRequest.pageSize);

        if (response) {
          if (response.rows) {
            data = response.rows;
          }
          setPaginationResult(response);
        }
      } catch(e) {
        console.error(e);
      }

      setNoticeList(data);
      setLoading(false);
    }

    fetchNotices()
    return () => setLoading(true);
  }, [paginationRequest, moduleNo]);

  return (
    <>
      {loading && <Loading />}
      <NoticeView
        list={list}
        boardLabel={moduleNo !== BOARD_NOTICE_MODULE_NO ? list.subject : undefined}
        noticeList={noticeList}
        goDetail={goDetail}
        paginationRequest={paginationRequest}
        paginationResult={paginationResult}
        setPaginationRequest={setPaginationRequest}
      />
    </>
  );
}
